import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {firebaseConnect} from 'react-redux-firebase';
import { withTranslation } from "react-i18next";
import * as actionsAccountModal from '../../actions/accountModalActions';
import CaQuizzesListView from "./CaQuizzesListView";

class CaQuizzesListContainer extends React.Component {

    constructor(props){
        super(props);
    }

    onQuizClick(id) {
        window.location.href="/quiz/"+id;
    }

    render(){
        const {quizData} = this.props;

        return(
            <CaQuizzesListView
                header={this.props.t('quizzes.quiz_list_header')}
                cta={this.props.t('quizzes.take_quiz_cta')}
                ctaCallback={(id)=>this.onQuizClick(id)}
                items={quizData}
            />
        )
    }
}

export default compose(
    connect((state) => ({
        auth: state.firebase.auth,
        profile:state.firebase.profile,
    }), Object.assign({},actionsAccountModal)),
    firebaseConnect(),
)(withTranslation("translations")(CaQuizzesListContainer))

